/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Cta_SubtitleInputs */

const en_fc_home_cta_subtitle = /** @type {(inputs: Fc_Home_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the FilmCraft video editor for free, try it online or follow the beginner tutorial.`)
};

/**
* | output |
* | --- |
* | "Download the FilmCraft video editor for free, try it online or follow the beginner tutorial." |
*
* @param {Fc_Home_Cta_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_cta_subtitle = /** @type {((inputs?: Fc_Home_Cta_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Cta_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_cta_subtitle(inputs)
});
export { fc_home_cta_subtitle as "fc.home.cta.subtitle" }